var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512,437v7c-4.8,12.9-18.2,21.1-30.9,12.4L5.5,84l-5.5-9v-9c4.6-12.2,15.6-18.7,28.2-12.7l91.3,71.7c19.7-13.6,39.6-25.6,62.3-33.7,118.5-42.7,232.6,21.5,289.4,126.1,20.6,37.9,19.2,44.4-2,81.3-13.1,22.8-29.2,43.7-47.2,62.8l86.8,69.2,3.2,6.3ZM151,148l38.5,30.7c70.9-61.1,176.9-4.6,168.4,88.6-1.1,12.3-6.4,23.6-10.8,34.9l42.9,33.3h2c16.1-15.9,30.8-34.4,42.2-54,2.8-4.8,13.1-22.8,12.8-27s-14.7-29.4-18.6-35.5c-50.6-79.7-140.9-127.1-234.7-92.8-15.2,5.5-28.9,13.6-42.8,21.8ZM316,278c15.9-42.3-17.1-87.8-62-86,2.6,12.6.4,24.1-3.5,36l65.5,50Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6,180.1c1.1-.3,2.1,0,2.9.9l27.4,22.6c-11.1,17.2-23,34.2-30.5,53.5,24.1,52.7,64.4,100.1,118.2,123.8s95.3,21.2,140.7,1.4l33.6,26.3c-46.5,25.9-103.6,32.1-155.2,19.2-71.1-17.8-129-71.5-163-135-13.2-24.6-18.7-32.1-6.7-59,3.1-6.9,28.3-52.3,32.5-53.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154,250c.6-.7,8.8,5.7,9.9,6.6,9,6.9,27.1,19.4,34.1,26.9s5,8.4,8,12c9.2,11.4,22.7,19.7,36.9,23.1l43.1,33.9c-50,19.1-108.4-11.8-126-61-1.8-5-6-18.3-6-23v-18.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.ff09394a892459ade07ce5fb8ea8878e.svg";
export { ForwardRef as ReactComponent };